import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema, NoteCornSchema } from '../base.js';
import { NoteSchema } from '../entities/note.js';
export const UpdateNoteBodySchema = z.object({
    title: z.string().optional(),
    text: z.string().optional(),
});
export const UpdateNoteApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        noteId: NoteCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: UpdateNoteBodySchema,
    response: NoteSchema,
};
export const UpdateNoteRequestSchema = UpdateNoteApiSchema.params
    .merge(UpdateNoteApiSchema.body)
    .merge(UpdateNoteApiSchema.headers);
